import request from '@/utils/request'

export function getTransferList(data) {
  return request.post('/wxfwh/transfer-list', data)
}

export function modifyTransferStatus(data) {
  return request.post('/wxfwh/transfer-modify-status', data)
}



// WEBPACK FOOTER //
// ./src/api/transfer.js